import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=1f1b3551&scoped=true&"
import script from "./RecordItem.vue?vue&type=script&lang=js&"
export * from "./RecordItem.vue?vue&type=script&lang=js&"
import style0 from "../../../less/gift.less?vue&type=style&index=0&id=1f1b3551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b3551",
  null
  
)

export default component.exports